import Header from './Header.container';

export default Header;